import React from "react"
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
// import {useMediaQuery} from 'react-responsive'

export default function CustomCard(props) {
    const {title, content} = props

    // const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1000)' })

    return (<>
        <Card sx={{ minWidth: 275, paddingX: 5}}>
            <CardContent>                   
                <Typography variant="h6" color="text.primary" gutterBottom>
                    {title}
                </Typography>
    
                <Typography variant="p" color="text.secondary">
                    {content}
                </Typography>       
            </CardContent>
        </Card>
    </>)
}